let cached = null;

function bufToB64(buf) {
    const bytes = new Uint8Array(buf);
    let binary = '';
    const chunk = 0x8000;
    for (let i = 0; i < bytes.length; i += chunk) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
    }
    return btoa(binary);
}

export async function loadNotoSansFonts() {
    if (cached) return cached;
    const base = `${process.env.PUBLIC_URL || ''}/fonts`;
    const [regularRes, boldRes] = await Promise.all([
        fetch(`${base}/NotoSans-Regular.ttf`),
        fetch(`${base}/NotoSans-Bold.ttf`)
    ]);
    if (!regularRes.ok || !boldRes.ok) return null;
    const [regular, bold] = await Promise.all([regularRes.arrayBuffer(), boldRes.arrayBuffer()]);
    cached = { regular: bufToB64(regular), bold: bufToB64(bold) };
    return cached;
}

export function applyNotoSans(doc, fonts) {
    if (!fonts) return 'helvetica';
    doc.addFileToVFS('NotoSans-Regular.ttf', fonts.regular);
    doc.addFileToVFS('NotoSans-Bold.ttf', fonts.bold);
    doc.addFont('NotoSans-Regular.ttf', 'NotoSans', 'normal');
    doc.addFont('NotoSans-Bold.ttf', 'NotoSans', 'bold');
    doc.setFont('NotoSans', 'normal');
    return 'NotoSans';
}
